import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    this.validate();
  }

  validate() {
    const field = (suffix) => this.element.querySelector(`[name$="[${suffix}]"]`);
    const commercial = parseFloat(field("commercial_value")?.value);
    const customs = field("taxable_amount");
    const gross = parseFloat(field("gross_weight_kg")?.value);
    const net = field("net_weight_kg");
    // Edit forms have no currency select; the article currency comes via a
    // data attribute instead. commercial_value is in that currency while
    // customs value is EUR, so the comparison only holds for EUR articles.
    const currency = field("currency")?.value || this.element.dataset.articleValidationCurrency;
    const eurArticle = !currency || currency.toUpperCase() === "EUR";

    if (customs) {
      const value = parseFloat(customs.value);
      customs.setCustomValidity(
        eurArticle && !isNaN(commercial) && !isNaN(value) && value < commercial
          ? "Customs value must be greater than or equal to the commercial value"
          : ""
      );
    }
    if (net) {
      const value = parseFloat(net.value);
      net.setCustomValidity(
        !isNaN(gross) && !isNaN(value) && value > gross
          ? "Net weight cannot exceed gross weight"
          : ""
      );
    }
  }
}
